<style>
    .rd-snackbar-container{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10000;
        bottom: 0;
    }
    .rd-snackbar {
        display: block;
        position: relative;
        width: auto;
        opacity: 0;
        bottom: -100px;
        padding: 8px 12px;
        background-color: var(--card-background);
        border-color: var(--card-background);
        box-shadow: var(--card-box-shadow);
        border-radius: 5px;
        transition: all .5s ease;
        transition-property: top,right,bottom,left,opacity;
        margin-bottom: 20px;
    }
    .rd-snackbar.show{
        bottom: 20px;
        opacity: 1;
    }
    .rd-snackbar img{
        height: 44px;
        width: 44px;
        object-fit: cover;
        border-radius: 5px;
    }
    .rd-snackbar-body{
        min-width: 156px;
    }
</style>

<script>
    
    export default {
        name: 'Snackbar',
        components: {

        },
        data() {
            return {
                snackbars: [],
                duration: 6000
            }
        },
        watch: {

        },
        computed: {
            
        },
        created: function () {
            window.RDSnackbar = this;
        },
        mounted: function () {
            var self = this;

        },
        methods: {
            show: function(data){
                var self = this;
                var item = {
                    id: Math.random(),
                    show: false,
                    text: data.text || '',
                    image_url: data.image_url || null,
                    action_text: data.action_text || 'Dismiss',
                    action_callback: data.action_callback || null
                };
                this.snackbars.push(item);
                setTimeout(function(){
                    item.show = true;
                }, 50);
                
                var duration = data.duration || this.duration;
                setTimeout(function(){
                    self.remove(item);
                }, duration);
            },
            remove: function(item){
                item.show = false;
            },
            callback: function(snackbar){
                if(snackbar.action_callback){
                    snackbar.action_callback();
                }
                this.remove(snackbar); //Remove by default when clicking the action button
            },
            onTransitionEnd: function(event, snackbar){
                var self = this;
                var element = event.target;
                var opacity = window.getComputedStyle(element).opacity;
                if (event.propertyName === 'opacity' && opacity === '0') {
                    var index = this.snackbars.indexOf(snackbar);
                    if(index > -1){
                        this.snackbars.splice(index, 1);
                    }
                }
            }
        },

    };
</script>


<template>
    <div id="snackbar" class="rd-snackbar-container">
        <div class="rd-snackbar" v-for="snackbar in snackbars" :key="snackbar.id" :class="{show: snackbar.show}" @transitionend="onTransitionEnd($event, snackbar)">
            <div class="row no-gutters align-items-center flex-nowrap">
                <div class="col-auto" v-if="snackbar.image_url">
                    <img class="mr-2" :src="snackbar.image_url">
                </div>
                <div class="col">
                    <div class="rd-snackbar-body" v-html="snackbar.text"></div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary ml-2" @click="callback(snackbar)">{{snackbar.action_text || 'Dismiss'}}</button>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/misc/snackbar.vue